module.exports = __webpack_public_path__ + "static/media/arrow_teal.6c750162.svg";